var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBelarus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 39.9999C31.0455 39.9999 39.9998 31.0456 39.9998 19.9999C39.9998 8.95424 31.0455 -6.10352e-05 19.9998 -6.10352e-05C8.95406 -6.10352e-05 -0.000244141 8.95424 -0.000244141 19.9999C-0.000244141 31.0456 8.95406 39.9999 19.9998 39.9999Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2607 18.5506L6.08679 14.6067L8.2607 10.7245L10.4346 14.6067L8.2607 18.5506Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91292 18.5506L1.73901 14.6067L3.91292 10.7245L6.08683 14.6067L3.91292 18.5506Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2607 29.2753L6.08679 25.3313L8.2607 21.4492L10.4346 25.3313L8.2607 29.2753Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91292 29.2753L1.73901 25.3313L3.91292 21.4492L6.08683 25.3313L3.91292 29.2753Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4347 3.88214L9.81923 2.78308C8.71533 3.43714 7.67994 4.19441 6.72595 5.0416L8.2608 7.82605L10.4347 3.88214Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26081 32.1738L6.70972 34.9438C7.66284 35.7921 8.69753 36.5505 9.80096 37.2059L10.4348 36.056L8.26081 32.1738Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1738 25.2174V38.4098C14.5777 39.433 17.2224 40 19.9999 40C28.5992 40 35.9301 34.5725 38.7559 26.9565L12.1738 25.2174Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7559 26.9564C39.5599 24.7898 39.9999 22.4463 39.9999 19.9999C39.9999 8.95431 31.0455 -6.10352e-05 19.9999 -6.10352e-05C17.2227 -6.10352e-05 14.5777 0.56658 12.1738 1.58963V26.9565H38.7559V26.9564Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelarus);
export default __webpack_public_path__ + "static/media/belarus.18630df7264d2cbc19a0127186c17495.svg";
export { ForwardRef as ReactComponent };